import rawThemeText from '@/config/themeText.json';

type ThemeSheet = Record<string, Record<string, string>>;
const themeText = rawThemeText as ThemeSheet;

export type ThemeType = number;
export type ThemedKey = string;

export function themeT(key: ThemedKey, themeType: ThemeType = 1): string {
  const selectedTheme = themeText[String(themeType)] ? String(themeType) : '1';
  const themeStrings = themeText[selectedTheme];

  return themeStrings?.[key] ?? key.charAt(0).toUpperCase() + key.slice(1);
}
